export const permissionsData = {
    'canEdit': 'canEdit',
    'hasApprover': 'hasApprover',
    'hasBuyer': 'hasBuyer'
}
